const withSummary = (summary?: string) => (summary ? `: ${summary}` : "");

export const CHAT_CHECKOUT_NOTE_LABEL = "App update:";

export const CHAT_CHECKOUT_NOTES = {
  started: (kind: string, party: string, summary?: string) =>
    summary
      ? `Checkout started for the ${kind}: ${summary}. The traveler form for ${party} is open.`
      : `Checkout started for the ${kind}: the traveler form for ${party} is open.`,
  traveler: (position: number, total: number, type: string) => `Traveler ${position} of ${total} (${type})`,
  travelerDone: (traveler: string, firstName: string) => `${traveler} is filled out: ${firstName}.`,
  travelerError: (traveler: string, reason: string) => `${traveler} could not be saved: ${reason}`,
  travelersError: (reason: string) => `The traveler details could not be saved: ${reason}`,
  roomsDone: "Room assignment is done.",
  roomsError: (reason: string) => `Room assignment could not be saved: ${reason}`,
  paymentOpen: "The payment form is open.",
  payInvalid: (reason: string) => `Pay did not start: ${reason}`,
  payFailed: (reason: string) => `The payment failed: ${reason}`,
  booked: (kind: string, summary?: string) =>
    `The payment went through and the ${kind} is booked${withSummary(summary)}. The confirmation will be emailed.`,
  inProgress: (kind: string, summary?: string) =>
    `The payment went through and the ${kind} booking is in progress${withSummary(
      summary
    )}. The confirmation will be emailed once it's confirmed.`,
  documentDate: "a document date needs fixing.",
};

export const CHAT_CHECKOUT_SUMMARY = {
  leg: (label: string, date: string, details: string) => `${label} ${date}: ${details}`,
  route: (from: string, departs: string, to: string, arrives: string) => `${from} ${departs} to ${to} ${arrives}`,
  nextDay: (days: number) => ` (+${days} ${days === 1 ? "day" : "days"})`,
  fareFamily: (brand: string) => `fare family ${brand}`,
  stay: (checkIn: string, checkOut: string, nights: number) =>
    `${checkIn} to ${checkOut}, ${nights} ${nights === 1 ? "night" : "nights"}`,
  total: (amount: string) => `total ${amount}`,
  policy: (text: string) => `cancellation policy: ${text}`,
};

export const CHAT_CHECKOUT_NOTE_KINDS: Record<string, string> = {
  hotel: "stay",
  flight: "flight",
};

export const CHAT_CHECKOUT_NOTE_PAX: Record<string, [string, string]> = {
  ADT: ["adult", "adults"],
  CHD: ["child", "children"],
  INF: ["infant", "infants"],
};

export const CHAT_CHECKOUT_NOTE_ROOM: [string, string] = ["room", "rooms"];
